import { useMutation } from "@tanstack/react-query";
import { request } from "../../../services/axios.service";
import { apiUrls } from "../../api-urls";

const remove = async (data: { _id: string }) => {
  const response: TServerResponse = await request({
    url: apiUrls.partners.DELETE_PARTNER,
    method: "POST",
    data,
  });
  return response;
};

export const useRemovePartnerMutation = () => {
  return useMutation({ mutationFn: remove });
};
